/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "page/Dashboard";
// import RTL from "layouts/rtl";
import Laporan from "page/Laporan";
import CustomerProfile from "layouts/profile/CustomerProfile";
import HartaDetails from "layouts/profile/HartaDetails";
import SignIn from "layouts/authentication/sign-in";
import ZonDanKategoriKutipan from "page/ZonDanKategoriKutipan";
import MaklumatPelanggan from "page/MaklumatPelanggan";
import MaklumatPenyewa from "page/MaklumatPenyewa";
import SenaraiHarta from "page/SenaraiHarta";
import TerimaanHasil from "page/KEW/TerimaanHasil";
import TerimaanLaporan from "page/KEW/TerimaanLaporan";
import JanaInbois from "page/JanaInbois";
import AutoJanaInbois from "page/AutoJanaInbois";
import NotisTunggakan from "page/NotisTunggakan";
import NotisTunggakanUUU from "page/UUU/NotisTunggakan";
import QRPage from "page/QRPage";
import QRGenerator from "page/QRGenerator";
import AdminHome from "page/Admin/AdminHome";
import NamaList from "page/Admin/NamaList";
import AkaunList from "page/Admin/AkaunList";
import HartaList from "page/Admin/HartaList";
import KategoriKutipanList from "page/Admin/KategoriKutipanList";
import ZonList from "page/Admin/ZonList";
import InboisList from "page/Admin/InboisList";
import LejarList from "page/Admin/LejarList";
import TerimaanList from "page/Admin/TerimaanList";
import DepositList from "page/Admin/DepositList";
import AdminSession from "page/Admin/Session";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "title",
    title: "Dashboard",
    key: "dashboard-title",
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon>dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Notis Tunggakan",
    key: "notis-tunggakan",
    icon: <Icon>notification_important</Icon>,
    route: "/notis-tunggakan",
    component: <NotisTunggakan />,
  },
  {
    type: "title",
    title: "Inbois Sewaan",
    key: "inbois-sewaan",
  },
  {
    type: "collapse",
    name: "Auto Jana Inbois",
    key: "auto-jana-inbois",
    icon: <Icon>receipt_long</Icon>,
    route: "/inbois-sewaan/auto-jana-inbois",
    component: <AutoJanaInbois />,
  },
  {
    type: "collapse",
    name: "Jana Inbois",
    key: "jana-inbois",
    icon: <Icon>note_add</Icon>,
    route: "/inbois-sewaan/jana-inbois",
    component: <JanaInbois />,
  },
  {
    type: "title",
    title: "Laporan",
    key: "laporan",
  },
  {
    type: "collapse",
    name: "Laporan",
    key: "laporan",
    icon: <Icon>history</Icon>,
    route: "/laporan/laporan",
    component: <Laporan />,
  },
  {
    type: "title",
    title: "Pelanggan",
    key: "pelanggan",
  },
  {
    type: "collapse",
    name: "Maklumat Pelanggan",
    key: "maklumat-pelanggan",
    icon: <Icon>person</Icon>,
    route: "/pelanggan/maklumat-pelanggan",
    component: <MaklumatPelanggan />,
  },
  {
    type: "title",
    title: "Senggara",
    key: "senggara",
  },
  {
    type: "collapse",
    name: "Senarai Penyewa",
    key: "senarai-penyewa",
    icon: <Icon>people</Icon>,
    route: "/senggara/senarai-penyewa",
    component: <MaklumatPenyewa />,
  },
  {
    type: "collapse",
    name: "Senarai Harta",
    key: "senarai-harta",
    icon: <Icon>home</Icon>,
    route: "/senggara/senarai-harta",
    component: <SenaraiHarta />,
  },
  {
    type: "collapse",
    name: "Senarai Zon dan Kategori Kutipan",
    key: "senarai-zon-dan-kategori-kutipan",
    icon: <Icon>category</Icon>,
    route: "/senggara/senarai-zon-dan-kategori-kutipan",
    component: <ZonDanKategoriKutipan />,
  },
  // Hidden routes (not shown in sidebar)
  {
    type: "route",
    route: "/notis/tunggakan",
  component: <NotisTunggakanUUU />,
  },
  {
    type: "route",
    route: "/profile/customer/:idNama",
    component: <CustomerProfile />,
  },
  {
    type: "route",
    route: "/harta/:kodHarta",
    component: <HartaDetails />,
  },
  {
    type: "route",
    route: "/harta/:kodHarta/:noAkaun",
    component: <HartaDetails />,
  },
  {
    type: "route",
    route: "/terimaan/terimaan-hasil",
    component: <TerimaanHasil />,
  },
  {
    type: "route",
    route: "/laporan/terimaan",
    component: <TerimaanLaporan />,
  },
  {
    type: "route",
  route: "/authentication/sign-in",
    component: <SignIn />,
    protected: false,
  },
  // Public QR landing page (mobile-friendly)
  {
    type: "route",
    route: "/qr",
    component: <QRPage />,
    protected: false,
    key: "qr",
  },
  {
    type: "route",
    route: "/qr/:no_akaun",
    component: <QRPage />,
    protected: false,
    key: "qr-with-akaun",
  },
  {
    type: "route",
    route: "/qr-preview/:no_akaun",
    component: <QRGenerator />,
    protected: false,
    key: "qr-preview",
  },
  // Hidden route for Admin; visible in sidenav only for admin users via roleBasedRoutes
  {
    type: "route",
    route: "/admin",
    component: <AdminHome />,
  },
  { type: "route", route: "/admin/nama", component: <NamaList /> },
  { type: "route", route: "/admin/akaun", component: <AkaunList /> },
  { type: "route", route: "/admin/harta", component: <HartaList /> },
  { type: "route", route: "/admin/kategori-kutipan", component: <KategoriKutipanList /> },
  { type: "route", route: "/admin/zon", component: <ZonList /> },
  { type: "route", route: "/admin/inbois", component: <InboisList /> },
  { type: "route", route: "/admin/lejar", component: <LejarList /> },
  { type: "route", route: "/admin/terimaan", component: <TerimaanList /> },
  { type: "route", route: "/admin/deposit", component: <DepositList /> },
  { type: "route", route: "/admin/sessions", component: <AdminSession /> },
];

export default routes;
